<template>
    <div>
        <div class="dx-field-label dinesafe-label">Select a payment option</div>

        <div ref="paypalRef" class="paypal-buttons"/>

        <div id = 'paypal-button'/>

        <!--<div class='create-account-button'>
            <DxButton 
                ref="btnCreateAccountOkRef" 
                type="success"
                text="Create Account"
                styling-mode="contained" 
                width="180"
                :visible.sync="createAccountVisible"
                @click="btnCreateAccountOkClick"
            />
        </div>-->
    </div>
</template>

<script>
    import {DxButton} from 'devextreme-vue';
    import DxTextBox from "devextreme-vue/text-box";
    import notify from 'devextreme/ui/notify';

    //PayPal stuff
    /*import defaultProps from '../utils/defaultProps';
    import additionalProps from '../utils/additionalProps';
    import { propTypes, assignToPropertyObject } from '../utils/paypalProp';

    const assignTo = assignToPropertyObject(additionalProps);

    const receiveMessage = (event) => {
        if (event.origin !== "http://example2.org/parent.html") {
            return;
        }
        // Do something here
    }
    
    document.addEventListener("message", receiveMessage, false);
    */

    export default {
        props: {
            accountInfo: null,
        },
        components: {
            DxButton,
            DxTextBox,
        },
        data() {
            //const testData = service.getTestData();

            return {
               createAccountDisabled: true,
               createAccountVisible: false,
            }
        },
        mounted(){   
            const script = document.createElement("script");
            
            //script.src = "https://www.paypal.com/sdk/js?client-id=sb&vault=true";  //vault=true means this is a subscription
            //script.src = "https://www.paypal.com/sdk/js?client-id=AarRD6J39UoonogT_-Q2qWtdjkcMe0JxbG2ogSq6uotKg6PcAMgUaT2MXWvran_fPQBKepEQTB6UCiqU&vault=true";  //vault=true means this is a subscription
            
            //vault=true --> This is a subscription
            //disable-funding=credit" --> Remove the PayPal Credit button
            
            //Almost working
            //script.src = "https://www.paypal.com/sdk/js?client-id=AXuz6BBN3tRqLXnpKW1ShCeuqHlxCK9_hJX9IA0AmfBgv1BaYuEXYlvzhtXHmOP1N2udkuk1ZrwA9U8h&vault=true&disable-funding=credit"; // DineSafeVT 
            
            //script.src = "https://api.sandbox.paypal.com/sdk/js?client-id=AXuz6BBN3tRqLXnpKW1ShCeuqHlxCK9_hJX9IA0AmfBgv1BaYuEXYlvzhtXHmOP1N2udkuk1ZrwA9U8h&vault=true&disable-funding=credit"; // 
            
            
            //Sandbox PayPal App, Sandbox PayPal user.  This works
            //script.src = "https://www.paypal.com/sdk/js?client-id=AarRD6J39UoonogT_-Q2qWtdjkcMe0JxbG2ogSq6uotKg6PcAMgUaT2MXWvran_fPQBKepEQTB6UCiqU&vault=true&disable-funding=credit"; // Sandbox clientId
            
            //PROD
            script.src = "https://www.paypal.com/sdk/js?client-id=ARPUDgnsAruzD-_oGUeGHEo7DGD5qMIbgXgEUvtULANhyOjgIliP3sORYpw5ngC88-clDKuVLeBa1Eac&vault=true&disable-funding=credit"; // PROD clientId

            //SANDBOX PayPal App, Sandbox PayPal - Old stuff - This works
            //script.src="https://www.paypal.com/sdk/js?client-id=ARpWGhYs5xmewBvyO_PEpsvPABdSSgI0rGOLumsC3OGqr0lWsSvHmk9h5ethMf49SVRXHYGwV9zYIhuf&vault=true&disable-funding=credit";

            script.addEventListener("load", this.setLoaded);

            //script.addEventListener("message", receiveMessage, false);

            document.body.appendChild(script);

            //------------------
            //paypal.Button.render(button, vue.$el);
            //window.paypal.render(this.$refs.paypalRef);

            //paypal.Button.render(button, this.$refs.paypalRef);
            
            //paypal.Buttons.render(button, this.$el);

            

            //paypal.Buttons.render('id');
        },
        methods:{
            onAuthorize(data, actions) {
                console.log('onAuthorize');
            },
            onApprove: function(data, actions, resp) {
                console.log('onApprove');
            },
            createSubscription: function(data, actions) {
                console.log('createSubscription');
            },
            setLoaded: function(resp) {
                this.loaded = true;

                //window.Vue

                window.paypal
                    .Buttons({
                        style: {
                            shape: 'rect',
                            color: 'gold',
                            layout: 'vertical',
                            label: 'subscribe'
                    },
                    createSubscription: function(data, actions) {
                        return actions.subscription.create({
                            //'plan_id': 'P-92U6388702663325WL5VBRDA' //Old Prod?  Don't use this

                            //'plan_id': 'P-983266002N940124DL5WN2PY'   //Sandbox
                            'plan_id': 'P-9AJ69114P5342820CL66SUMQ' //PROD 2020/11/24
                        });
                    },
                    onApprove: function(data, actions, resp) {
                        //---------------------
                        //Create a the new Account in our database                       
                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type","application/json;charset=utf-8");

                        //AJT ToDo - Check LocalStorage to see if this is a new Subscription or a Resubscribe
                        //  If this is a Resubscribe, then LocalStorage should have the AccountId -> localStorage.dinesafeData.AccountId
                        //  (When Auth.js navigates to the Renew page, it should get the AccountInfo and store it to localStorage.dinesafeData.)

                        // If this is a Resubscribe, update the Subscription for the Account
                        // Else, create a new Admin Account

                        //Get the Account Information that was stored to LocalStorage from the calling component
                        let accountInfo =  JSON.parse(localStorage.dinesafeData);
                        accountInfo.SubscriptionId = data.subscriptionID;
                        localStorage.dinesafeData = JSON.stringify(accountInfo);
                        
                        //Check if this is a Resubscribe (reactivation of a previous subscription)
                        if(JSON.parse(localStorage.dinesafeData).Resubscribe == true){
                            //Update the SubscriptionId of the existing Account

                            /*
                                var body = {
                                AccountId:"D903E3FE-3B2D-4313-8BE3-01B06BD1FB66",
                                SubscriptionId:data.subscriptionID
                            }
                            */
                            
                            var requestOptions = {
                                method: 'POST',
                                headers: myHeaders,
                                body: JSON.stringify(accountInfo),
                                redirect: 'follow'
                            };

                            fetch("service/ContactTracingService.svc/UpdateAccountSubscription", requestOptions)
                            .then(
                                response => response.text()
                            )
                            .then(
                                result => {
                                    if(result != ''){
                                        var jResult = JSON.parse(JSON.parse(result));
                                    }
                                    
                                    //let accountInfo =  JSON.parse(localStorage.dinesafeData);
                                    //accountInfo.AccountId = jResult.AccountId;

                                    //localStorage.dinesafeData = JSON.stringify(accountInfo);
                        
                                    //Navigate to the admin form
                                    location.href='#/admin';
                                }
                            )
                            .catch(
                                error => {
                                console.log('error', error)
                                }
                            );
                        }
                        else{
                            //Create a new Account record with the new subscriptionId

                            /* For testing
                            let accountInfoTest = {
                                FirstName: 'test',
                                LastName: 'test',
                                Password: 't',
                                Email: 'test21@mail.com',
                                PhoneNumber: '5555555555',
                                Address: '123 Main St',
                                City: 'Townsville',
                                StateProvince: 'VT',
                                PostalCode: '11111',
                                BusinessName: 'Test Business',
                                BusinessDesc: 'Test Desc',
                                SubscriptionId: '12345',
                            };
                            */

                            var requestOptions = {
                                method: 'POST',
                                headers: myHeaders,
                                body: JSON.stringify(accountInfo),
                                redirect: 'follow'
                            };

                            fetch("service/ContactTracingService.svc/CreateAdminAccount", requestOptions)
                            .then(function(response){
                                    return response.json();
                                }
                            )
                            .then(function(result){
                                    if(result != ''){
                                        //console.log("result " + result);
                                        //console.log("parse " + JSON.parse(result));
                                        //console.log("parse [0] " + JSON.parse(result)[0]);
                                        //console.log("parse [0].AccountId " + JSON.parse(result)[0].AccountId);
                                        //var jResult = JSON.parse(result);                                    
                                        //var jResult = result;
                                    
                                        //Store the Account info for the new account to localStorage
                                        //let accountInfo =  JSON.parse(localStorage.dinesafeData);
                                        //accountInfo.AccountId = jResult.AccountId;

                                        //localStorage.dinesafeData = JSON.stringify(accountInfo);
                                       
                                        //console.log("parse parse .AccountId " + JSON.parse(JSON.parse(result)).AccountID);

                                        localStorage.dinesafeAccountId = JSON.parse(result)[0].AccountId;
                            
                                        //Navigate to the admin form
                                        location.href='#/admin';
                                    }
                                }
                            )
                            .catch(
                                error => {
                                console.log('error', error)
                                }
                            );
                            //location.href='#/admin';
                        }
                    },
                    onCancel: function(data) {
                        //location.href='www.google.com';
                    },
                    /*onApprove: async (data, actions, resp) => {
                        this.loadding = true;
                        const order = await actions.order.capture();
                        this.data;
                        this.paidFor = true;
                        this.loadding = false;
                        window.location.href = "./paymentsuccess/" +this.resp;
                    },*/
                    onError: err => {
                        console.log(err);
                    }
                })
                .render(this.$refs.paypalRef);
            },
        }
    }
</script>

<style scoped>
    .dinesafe-label{
        padding-bottom:10px;
    }
    
    /*
    .create-account-button{
        display: flex; 
        justify-content: center;
    }

    .create-account-button > .dx-button-mode-outlined{
        color: #147c33;
        border-color: #147c33;
    }
    */

    .continue-to-payment{
        display: flex; 
        justify-content: center;
        padding-top: 10px;
    }

    .dx-field-label{
        width: 100%;
        padding-top: 20px;
    }

    .create-account-input {
        padding-bottom: 10px;
        padding-top:10px;

        margin:auto;
        max-width: 400px;
    }
</style>